import { getContractTransactions } from "../../api/contracts";

const getDefaultState = () => {
    return { all: {} };
};

const state = getDefaultState();

const getters = {
    groups: state => {
        let groups = {};
        for (let contractId in state.all) {
            groups[contractId] = {};
            for (let year in state.all[contractId]) {
                groups[contractId][year] = [];
                for (let transactionIndex in state.all[contractId][year]
                    .Entries) {
                    let transaction =
                        state.all[contractId][year].Entries[transactionIndex];
                    if (
                        transactionIndex === "1" ||
                        groups[contractId][year][
                            groups[contractId][year].length - 1
                        ].BookingDate !== transaction.BookingDate
                    ) {
                        let group = {};
                        group.BookingDate = transaction.BookingDate;
                        group.transactions = [];
                        group.transactions.push(transaction);
                        groups[contractId][year].push(group);
                    } else {
                        groups[contractId][year][
                            groups[contractId][year].length - 1
                        ].transactions.push(transaction);
                    }
                }
            }
        }
        return groups;
    }
};

const actions = {
    getContractTransactions({ commit, state }, payload) {
        return new Promise(resolve => {
            if (
                !(payload.contractId in state.all) ||
                !(payload.year in state.all[payload.contractId])
            ) {
                commit("setLoading", true, { root: true });
            }
            getContractTransactions(payload.contractId, payload.year).then(
                response => {
                    if (
                        response.data.Status === 200 &&
                        Object.values(response.data.Result).length > 0
                    ) {
                        commit("setTransactions", {
                            contractId: payload.contractId,
                            year: payload.year,
                            transactions: response.data.Result
                        });
                        resolve();
                    }
                }
            );
        });
    }
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setTransactions(state, payload) {
        state.all = {
            ...state.all,
            [payload.contractId]: {
                ...state.all[payload.contractId],
                [payload.year]: payload.transactions
            }
        };
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
